var o=function(o){return o.id="id",o.access="access",o.refresh="refresh",o}({}),e=function(o){return o.Cognito="COGNITO",o.Google="Google",o.Facebook="Facebook",o.Amazon="LoginWithAmazon",o.Apple="SignInWithApple",o}({});export{e as CognitoHostedUIIdentityProvider,o as TokenTypes};
//# sourceMappingURL=types.js.map
